import { ViolationType } from "../-constants/violationType";

type User = {
	email?: string;
	workerNumber?: string;
};

type TraceableApp = {
	violationType?: (typeof ViolationType)[keyof typeof ViolationType];
};

/**
 * 訪問履歴がShadow IDかどうかを判定する
 * NOTE: Access台帳とID台帳をリニューアル予定なのと単純なロジックなのでフロントに実装
 */
export function isShadowIdVisit(
	loginId: string | null | undefined,
	user: User,
	traceableApp: TraceableApp,
): boolean {
	if (!loginId) {
		return false;
	}

	if (traceableApp.violationType !== ViolationType.SHADOW_ID) {
		return false;
	}

	const isDifferentEmail = user.email && loginId !== user.email;
	const isDifferentWorkerNumber =
		user.workerNumber && loginId !== user.workerNumber;

	return Boolean(isDifferentEmail || isDifferentWorkerNumber);
}
